/**
 * `1838` — *and only if {status, columnId} {is, isCondition} {something, columnValue}*.
 *
 * **Reads the item's live cell**, not the trigger payload: its inbound wiring declares `itemId`,
 * which is the evidence for the split in `specs/M6-A1` §5.3 (blocks `45`/`48` compare
 * trigger-carried values instead). An empty cell has no index, so it fails `is` and passes
 * `isnot`. The column may be a different column from the trigger's.
 */
import { z } from 'zod';
import { defineCondition } from '../block.js';
import { columnRefSchema, isConditionSchema, labelIndexOf, labelValueMatches, labelValueSchema } from '../values.js';
export const statusIsParams = z.object({
    columnId: columnRefSchema,
    isCondition: isConditionSchema,
    columnValue: labelValueSchema,
});
export const statusIsCondition = defineCondition({
    id: '1838',
    kind: 'condition',
    app: 'monday',
    sentencePartial: 'and only if {status, columnId} {is, isCondition} {something, columnValue}',
    paramsSchema: statusIsParams,
    requiredColumnTypes: ['status'],
    references: (params) => [{ kind: 'column', id: params.columnId.columnId, invalid: params.columnId.invalid }],
    async evaluate(context, params) {
        if (context.itemId === null)
            return false;
        const value = await context.services.getCellValue(context.itemId, params.columnId.columnId);
        const matches = labelValueMatches(params.columnValue, labelIndexOf(value));
        return params.isCondition === 'is' ? matches : !matches;
    },
});
//# sourceMappingURL=1838.js.map